<template lang="pug">
div.legals
	a.legals-link(v-on:click.stop="toggleContent()" v-for="(menu, index) in menufooter")
		span {{menu.title}}
	div.legals-content
		span.legals-close(v-on:click.stop="toggleContent()")
		div(v-html="content.copy")
</template>

<script>
import store from '@/store';
import Vue from 'vue';

export default {
	name: 'Legals',
	props: ['content'],
	computed:{
		menufooter(){
			return store.state.menufooter;
		}
	},
	methods: {
		toggleContent() {
			let content = this.$el.querySelector('.legals-content');
			content.classList.toggle('is-open');
			if(content.classList.contains('is-open')){
				this.$parent.$parent.winScrollTo(this.$el.parentNode);
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/features/Legals/index.vue